import _defineProperty from "E:/Prydwen Website/annwyn/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "E:/Prydwen Website/annwyn/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "E:/Prydwen Website/annwyn/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["as", "bsPrefix", "variant", "size", "active", "className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import classNames from 'classnames';
import * as React from 'react';
import { useButtonProps } from '@restart/ui/Button';
import { useBootstrapPrefix } from './ThemeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
var defaultProps = {
  variant: 'primary',
  active: false,
  disabled: false
};
var Button = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var as = _ref.as,
      bsPrefix = _ref.bsPrefix,
      variant = _ref.variant,
      size = _ref.size,
      active = _ref.active,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  var prefix = useBootstrapPrefix(bsPrefix, 'btn');

  var _useButtonProps = useButtonProps(_objectSpread({
    tagName: as
  }, props)),
      _useButtonProps2 = _slicedToArray(_useButtonProps, 2),
      buttonProps = _useButtonProps2[0],
      tagName = _useButtonProps2[1].tagName;

  var Component = tagName;
  return /*#__PURE__*/_jsx(Component, _objectSpread(_objectSpread(_objectSpread({}, buttonProps), props), {}, {
    ref: ref,
    className: classNames(className, prefix, active && 'active', variant && "".concat(prefix, "-").concat(variant), size && "".concat(prefix, "-").concat(size), props.href && props.disabled && 'disabled')
  }));
});
Button.displayName = 'Button';
Button.defaultProps = defaultProps;
export default Button;